module.exports = __webpack_public_path__ + "media/images/about/3-4790ce8bf162c9b1056f8eb9f052d2f8.jpg";